(function () {
  var coffretIds = new Set();
  var coffretKeys = [];
  var coffretTotal = 0;
  var coffretImg = '';
  var applyTimer = null;

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  async function loadCart() {
    try {
      var data = await fetch('/cart.js').then(function (r) { return r.json(); });
      coffretIds = new Set();
      coffretKeys = [];
      coffretTotal = 0;
      coffretImg = '';
      data.items.forEach(function (item) {
        if (item.properties && item.properties['_coffret'] === 'oui') {
          coffretIds.add(String(item.product_id));
          coffretKeys.push(item.key);
          coffretTotal += item.original_price;
          if (!coffretImg && item.featured_image && item.featured_image.url) {
            coffretImg = item.featured_image.url;
          }
        }
      });
    } catch (e) {}
  }

  function applyGrouping() {
    if (!coffretIds.size) return;
    if (document.querySelector('.coffret-kg')) return;

    var containers = [];
    document.querySelectorAll('.kaching-cart-item').forEach(function (el) {
      if (coffretIds.has(String(el.dataset.productId))) {
        var c = el.closest('.kaching-cart-item-container');
        if (c) containers.push(c);
      }
    });

    if (!containers.length) return;

    var trashIcon =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<polyline points="3 6 5 6 21 6"/>' +
        '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>' +
        '<path d="M10 11v6"/><path d="M14 11v6"/>' +
        '<path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>' +
      '</svg>';

    var group = document.createElement('div');
    group.className = 'coffret-kg';
    group.innerHTML =
      '<div class="coffret-kg__hd">' +
        (coffretImg ? '<img class="coffret-kg__img" src="' + coffretImg + '" alt="" width="60" height="60">' : '') +
        '<div class="coffret-kg__info">' +
          '<p class="coffret-kg__title">Coffret 7 bijoux</p>' +
          '<button class="coffret-kg__btn" type="button" aria-expanded="false">' +
            'Voir les 7 bijoux <span class="coffret-kg__arrow" aria-hidden="true">▾</span>' +
          '</button>' +
        '</div>' +
        '<div class="coffret-kg__right">' +
          '<div class="coffret-kg__prices">' +
            '<s class="coffret-kg__old">' + fmt(coffretTotal) + '</s>' +
            '<strong class="coffret-kg__new">99,00 €</strong>' +
          '</div>' +
          '<button class="coffret-kg__del" type="button" aria-label="Supprimer le coffret" title="Supprimer le coffret">' +
            trashIcon +
          '</button>' +
        '</div>' +
      '</div>';

    containers[0].parentNode.insertBefore(group, containers[0]);
    containers.forEach(function (c) {
      c.hidden = true;
      c.classList.add('coffret-kg-child');
    });

    group.querySelector('.coffret-kg__btn').addEventListener('click', function () {
      var open = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!open));
      containers.forEach(function (c) { c.hidden = open; });
      this.innerHTML =
        (open ? 'Voir les 7 bijoux' : 'Masquer les bijoux') +
        ' <span class="coffret-kg__arrow" aria-hidden="true">' + (open ? '▾' : '▴') + '</span>';
    });

    group.querySelector('.coffret-kg__del').addEventListener('click', async function () {
      this.disabled = true;
      var updates = {};
      coffretKeys.forEach(function (k) { updates[k] = 0; });
      try {
        var res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (res.ok) window.location.reload();
        else this.disabled = false;
      } catch (e) {
        this.disabled = false;
      }
    });
  }

  function scheduleApply() {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(applyGrouping, 200);
  }

  function injectStyles() {
    if (document.getElementById('coffret-kg-css')) return;
    var s = document.createElement('style');
    s.id = 'coffret-kg-css';
    s.textContent = [
      '.coffret-kg{padding:12px 0;border-bottom:1px solid rgba(0,0,0,.1);margin-bottom:4px}',
      '.coffret-kg__hd{display:flex;align-items:center;gap:12px;width:100%}',
      '.coffret-kg__img{width:60px;height:60px;object-fit:cover;border-radius:6px;flex-shrink:0}',
      '.coffret-kg__info{flex:1;min-width:0}',
      '.coffret-kg__title{font-size:.9rem;font-weight:700;margin:0 0 4px}',
      '.coffret-kg__btn{background:none;border:none;padding:0;cursor:pointer;font-size:.8rem;color:inherit;opacity:.65;font-family:inherit;line-height:1.4}',
      '.coffret-kg__btn:hover{opacity:1}',
      '.coffret-kg__right{display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex-shrink:0}',
      '.coffret-kg__prices{display:flex;flex-direction:column;align-items:flex-end;gap:2px}',
      '.coffret-kg__old{font-size:.78rem;opacity:.55;text-decoration:line-through}',
      '.coffret-kg__new{font-size:.95rem;font-weight:700}',
      '.coffret-kg__del{background:none;border:none;padding:0;cursor:pointer;color:inherit;opacity:.5;line-height:1;display:flex;align-items:center;justify-content:center}',
      '.coffret-kg__del:hover{opacity:1}',
      '.coffret-kg__del:disabled{opacity:.3;cursor:wait}',
      '.coffret-kg-child button,.coffret-kg-child input{display:none!important}',
    ].join('');
    document.head.appendChild(s);
  }

  async function init() {
    await loadCart();
    if (!coffretIds.size) return;

    injectStyles();

    new MutationObserver(function (mutations) {
      var hasNew = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            (n.classList && n.classList.contains('kaching-cart-item-container')) ||
            (n.querySelector && n.querySelector('.kaching-cart-item-container'))
          );
        });
      });
      if (hasNew) scheduleApply();
    }).observe(document.body, { childList: true, subtree: true });

    if (document.querySelector('.kaching-cart-item')) applyGrouping();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
